import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemButtonProps,
  ListItemText,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const ListItemTextSmall = styled(ListItemText)(({ theme }) => ({
  "& .MuiListItemText-primary": {
    fontSize: "0.8rem",
  },
}));

export const ListItemButtonSmall = styled(ListItemButton)<ListItemButtonProps>(
  ({ theme }) => ({
    padding: 0,
    margin: 0,
  }),
);

export const ListItemSmall = styled(ListItem)(({ theme }) => ({
  "& .MuiListItem-primary": {
    padding: 0,
    margin: 0,
  },
  padding: "0 8px 0 8px",
  margin: 0,
}));

export const ListSmall = styled(List)(({ theme }) => ({
  "& .MuiList-primary": {
    padding: 0,
    margin: 0,
  },
  padding: 0,
  margin: 0,
}));

export const IconButtonSmall = styled(IconButton)(({ theme }) => ({
  padding: "0 8px 0 8px",
  margin: 0,
  "& .MuiSvgIcon-root": {
    fontSize: "1.2rem",
  },
}));
